import React from 'react';
export const sidebarOpenSvg = (expanded) => {
    switch (expanded) {
        case true:
            return (
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.071 0.930005L8.485 2.343L3.828 7L13 7L13 9L3.828 9L8.485 13.657L7.071 15.071L0 8.00101L7.071 0.930005ZM15.001 15L15.001 1L17.001 1V15H15.001Z" fill="#565671"/>
                </svg>
            )
        case false:
            return (
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.929 15.07L8.515 13.657L13.172 9L4 9L4 7L13.172 7L8.515 2.343L9.929 0.928999L17 7.999L9.929 15.07ZM1.999 0.999998L1.999 15L-0.000999444 15L-0.000998221 0.999998L1.999 0.999998Z" fill="#565671"/>
                </svg>
            )

    }
}

